<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <hr>
    <div id="gameContainer"></div>
    <h3>Installed CLI Plugins</h3>
    <ul>
      <li>
        <a
          href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel"
          target="_blank"
          rel="noopener"
        >babel</a>
      </li>
      <li>
        <a
          href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint"
          target="_blank"
          rel="noopener"
        >eslint</a>
      </li>
    </ul>
  </div>
</template>

<script>
import GameEntry from "../Entry";

export default {
  name: "Site",
  props: {
    msg: String
  }
};

new GameEntry();

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
hr {
  margin-top: 20px;
  margin-bottom: 40px;
}
a {
  color: #42b983;
}
.gameContainer {
  width: 650px;
  height: 400px;
  background-color: black;
  display: inline-block;
}
</style>
